import { object } from "yup";
import { publicProfileSharedShape } from "@user-management-context/primary/teacher/teacher-public-profile-subform/teacher-public-profile.subform.schema";
import type { LeafId } from "@academy-context/shared/domain/types/enums/specializations";

export interface PublicProfileStepInputs {
  description: string;
  pedagogicalExperience: string;
  specializations: LeafId[];
  offersOnlineCoaching: boolean;
  websiteUrl: string;
  instagramUrl: string;
  youtubeUrl: string;
  tiktokUrl: string;
  facebookUrl: string;
  isPublicProfileVisibleByTeacher: boolean;
  isEmailVisibleOnPublicProfile: boolean;
}

export const publicProfileStepSchema = object(publicProfileSharedShape);
